import React, { Component } from 'react';
import { connect } from 'react-redux';

import { RadioButtonGroup, TextField } from 'redux-form-material-ui';
import { Field, reduxForm, hasSubmitFailed } from 'redux-form';

import { RadioButton } from 'material-ui/RadioButton';
import FlatButton from 'material-ui/FlatButton';

import reducer from 'reducers/referencesReducer';

import * as validator from 'helpers/Validator';
import { AccentColor } from 'helpers/AccentColorHelper';

class TenantPersonalReferenceVerificationForm extends Component {
  render() {
    const handleSubmit = this.props.handleSubmit;

    return (
      <form onSubmit={handleSubmit} style={{ marginTop: '25px' }}>
        <h5 style={{ textAlign: 'center', marginBottom: '5px' }}>
          Have you known <span style={{ fontWeight: 'bold' }}>
            {this.props.tenant_first_name}
          </span>{' '}
          for <span style={{ fontWeight: 'bold' }}>{this.props.duration}</span>?
        </h5>
        <Field
          name="duration_confirmed"
          component={RadioButtonGroup}
          validate={validator.required}
          style={{ width: '187px', margin: 'auto' }}
        >
          <RadioButton value="Yes" label="Yes" style={{ width: '102px', display: 'inline-flex' }} />
          <RadioButton
            value="No"
            label="No"
            style={{ width: '70px', display: 'inline-flex', float: 'right' }}
          />
        </Field>
        <h5 style={{ textAlign: 'center', marginBottom: '5px' }}>
          {' '}
          Would you categorize your relationship as{' '}
          <span style={{ fontWeight: 'bold' }}>{this.props.relationship}</span>?
        </h5>
        <Field
          name="relationship_confirmed"
          component={RadioButtonGroup}
          validate={validator.required}
          style={{ width: '187px', margin: 'auto' }}
        >
          <RadioButton value="Yes" label="Yes" style={{ width: '102px', display: 'inline-flex' }} />
          <RadioButton
            value="No"
            label="No"
            style={{ width: '70px', display: 'inline-flex', float: 'right' }}
          />
        </Field>
        <h5 style={{ textAlign: 'center', marginBottom: '5px' }}>
          {' '}
          Provide a few words for recommendation:{' '}
        </h5>
        <Field
          name="reference_text"
          component={TextField}
          hintText="Enter text here"
          hintStyle={{ textAlign: 'center' }}
          multiLine={true}
          fullWidth
          errorStyle={{ display: 'none' }}
          validate={validator.required}
          style={{ fontSize: '14px', marginBottom: '35px', width: '330px' }}
        />
        {this.props.submitFailed && (
          <div style={{ color: 'red', marginBottom: '10px' }}>
            {' '}
            Woops! Please fill out the entire form.{' '}
          </div>
        )}
        <div>
          <FlatButton
            label="Confirm"
            primary={true}
            type="submit"
            backgroundColor={AccentColor()}
            hoverColor="grey"
            style={{ color: 'white', marginTop: '10px' }}
          />
        </div>
      </form>
    );
  }
}

TenantPersonalReferenceVerificationForm = reduxForm({
  form: 'tenantPersonalReferenceVerificationForm',
})(TenantPersonalReferenceVerificationForm);

TenantPersonalReferenceVerificationForm = connect(
  state => ({
    submitFailed: hasSubmitFailed('tenantPersonalReferenceVerificationForm')(state),
  }),
  { load: reducer } // bind account loading action creator
)(TenantPersonalReferenceVerificationForm);

export default TenantPersonalReferenceVerificationForm;
